import React from 'react';

import { SocialAPI } from '@api/index';
import { BackTop } from '@element/index';
import { getRecommendStory } from '@utils/news';
import { FocusNews } from '@widget/news/FocusNews';
import { ListLayout } from '@widget/news/index';

const T = (props) => {
  const { recommend, squareStory } = props;
  console.log('line 7 要闻', recommend, squareStory);
  return (
    <ListLayout type="highlights" activeKey="highlights" recommend={recommend} asideTag={{ moduleTitle: 'h2', postTitle: 'h3' }}>
      <FocusNews squareStory={squareStory} recommend={recommend} />
      <BackTop />
    </ListLayout>
  );
};

export const getServerSideProps = async (ctx) => {
  const { jwt, zone } = ctx.req.cookies || {};
  const props = {};

  try {
    const [recommend, squareStory] = await Promise.all([
      getRecommendStory({ limit: 6, language: ctx.locale, zone: zone }),
      SocialAPI.getSquareStory(
        {
          limit: 20,
          id_lte: '',
          verb: 13
        },
        { Authorization: jwt }
      )
    ]);
    props.recommend = recommend;
    props.squareStory = squareStory;
  } catch (error) {}
  return { props };
};

export default T;
